import {RepositoryPickerCurrentRepoServerQuery} from '@github-ui/server-persisted-queries'
import type {RepositoryPickerCurrentRepoServerQueryQuery} from '@github-ui/server-persisted-queries/types/RepositoryPickerCurrentRepoServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export function repositoryQueryKey(owner: string, name: string) {
  return ['item-picker', 'repository', {owner, name}] as const
}

export async function fetchRepositoryFromServer(
  owner: string,
  name: string,
  signal?: AbortSignal,
): Promise<RepositoryPickerCurrentRepoServerQueryQuery['repository']> {
  const query = new URLSearchParams({queryId: RepositoryPickerCurrentRepoServerQuery})
  const response = await reactFetchJSON(`/${owner}/${name}/repository_picker_current_repo.json?${query.toString()}`, {
    signal,
  })

  if (!response.ok) throw new Error(`Repository fetch failed (${response.status})`)

  const json = (await response.json()) as {data?: RepositoryPickerCurrentRepoServerQueryQuery; errors?: unknown[]}
  if (json.errors?.length || !json.data) throw new Error('Repository query returned errors')

  return json.data.repository
}
